import React from 'react';
import PropTypes from 'prop-types';

const Tag = ({ text, ...other }) => (
  <div className="tag px-2 mr-2 font-weight-bold mb-1" {...other}>
    {text}
  </div>
);

Tag.propTypes = {
  text: PropTypes.string,
};

export default Tag;
